export const enum PayoutStatus {
  PAID = 'paid',
}
